<template>
  <section class="section-coupon">
    <div class="container">
      <span class="d-link-scan">
        <img src="@/assets/img/DAMAC_Logo.png" class="log-img" alt />
      </span>
      <div class="text-center" v-if="verifingCoupon >= 1">
        <h2 class="mb-3 text-white">{{ this.msgHeader }}</h2>
        <p class="mb-5 text-white" v-html="this.msgBody"></p>
        <div v-if="verifingCoupon == 1">
          <button class="btn btn-primary" @click="doBack()">Scan Again</button>
        </div>
        <div v-if="verifingCoupon==2">
          <button class="btn btn-primary mb-4" @click="doRedeem()">Redeem</button>
          <button class="btn btn-primary" @click="doBack()">Cancel</button>
        </div>
        <div v-if="verifingCoupon==3">
          <p class="text-white">{{ this.message }}</p>
          <button class="btn btn-primary" @click="doBack()">Home</button>
        </div>
      </div>
      <div class="text-center" v-else>
        <p class="text-white">Verifing Coupon</p>
      </div>
    </div>
  </section>
</template>
<script>
import { BASEURL } from "@/config/index";
let BaseURL = BASEURL;
import axios from "axios";
export default {
  name: "qrcode",
  data() {
    return {
      verifingCoupon: 0,
      msgHeader: "",
      msgBody: "",
      message: ""
    };
  },
  components: {},
  beforeMount() {
    this.$cookies.get("token");
  },
  mounted() {
    let token = this.$cookies.get("token");
    if (token) {
      this.verifytoken = 1;
      axios
        .post(`${BaseURL}/verifycoupon`, {
          token: token,
          couponcode: this.$route.params.couponcode
        })
        .then(
          response => {
            console.log(response);
            if (response && response.data && response.data["status"]) {
              //$cookies.set('token',response.data["token"]);
              //this.$router.push({name:"scanPage"});
              this.verifingCoupon = 2;
              this.msgHeader = response.data["msgHeader"];
              this.msgBody = response.data["msgBody"];
            } else {
              this.verifingCoupon = 1;
              this.msgHeader = response.data["msgHeader"];
              this.msgBody = response.data["msgBody"];
              //console.log("Api error");
              //this.verifytoken=0;
              //$cookies.remove('token');
            }
          },
          error => {
            console.log(error);
            //this.verifytoken=0;
            //$cookies.remove('token');
          }
        );
    } else {
      this.$router.replace({
        path: "login"
      });
    }
  },
  methods: {
    doBack: function() {
      this.$router.replace({ name: "scanPage" });
    },
    doRedeem: function() {
      let token = $cookies.get("token");
      console.log(token, "Token");
      if (token) {
        this.verifytoken = 1;

        axios
          .post(`${BaseURL}/redeemcoupon`, {
            token: token,
            couponcode: this.$route.params.couponcode
          })
          .then(
            response => {
              console.log(response);
              if (response && response.data && response.data["status"]) {
                this.verifingCoupon = 3;
              } else {
              }
              this.message = response.data["message"];
            },
            error => {
              console.log(error);
              //this.verifytoken=0;
              //$cookies.remove('token');
            }
          );
      }
    }
  }
};
</script>

<style>
.section-coupon {
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 47px);
}
</style>



// WEBPACK FOOTER //
// src/components/pages/couponStatus.vue